
import { LitElement, html } from 'lit';
import { property, queryAssignedElements } from 'lit/decorators.js';
import { literal } from 'lit/static-html.js';
import { C11nPrefix, C11nPrefixLiteral } from 'virtual:c11n-prefix';
import { appendStylesheet, c11nElement } from '../core';
import slotStyles from './accordion-group.slot.scss?inline';
import { AccordionComponent } from './accordion';

export type AccordionItemMargin = 'none' | 'medium' | 'large';

@c11nElement()
export class AccordionGroupComponent extends LitElement {
  static selector = `${C11nPrefix}-accordion-group`;
  static literal = literal`${C11nPrefixLiteral}-accordion-group`;

  @property({ attribute: 'multi-expandable', type: Boolean })
  multiExpandable?: boolean = false;

  @property({ attribute: 'item-margin', type: String })
  itemMargin?: AccordionItemMargin = 'none';

  @property({ attribute: 'c11n-web-accordion-group', type: Boolean, reflect: true })
  readonly _c11n_web_accordion_group: boolean = true;

  @queryAssignedElements({ selector: AccordionComponent.selector })
  accordionEls!: Array<AccordionComponent>;

  override connectedCallback(): void {
    super.connectedCallback();
    this.appendStyles();
    this.addEventListener('open', this.handleToggleOpen);
    this.addEventListener('close', this.handleEventEmitter);
  }

  override disconnectedCallback(): void {
    super.disconnectedCallback();
    this.removeEventListener('open', this.handleToggleOpen);
    this.removeEventListener('close', this.handleEventEmitter);
  }

  handleToggleOpen(e: Event) {
    this.accordionEls.forEach((accordionEl) => {
      if (
        !this.multiExpandable && 
        accordionEl !== e.target && 
        (accordionEl._open)
      ) {
        accordionEl.toggleAccordion();
      }
    });
    this.handleEventEmitter();
  }
  
  handleEventEmitter() {
    this.dispatchEvent( new CustomEvent('toggle', { bubbles: true, composed: true, detail: this.accordionEls.map((accordionEl)=> ({ accordionId: accordionEl.id, isOpen: accordionEl._open}))})); 
  }

  appendStyles() {
    const slotStylesheet: string = slotStyles.toString().replaceAll(/\bc11n-web-accordion-group\b/g, this.tagName.toLowerCase());
    appendStylesheet({ target: this, styles: slotStylesheet, name: `${this.tagName.toLowerCase()}-slot` });
  }

  override render() {
    return html` <slot></slot> `;
  }
}

export const C11nAccordionGroup = AccordionGroupComponent.selector;
export const C11nAccordionGroupLiteral = AccordionGroupComponent.literal;
